export const Logo = ({ dark = false }) => (
  <div className="leading-none select-none" data-testid="brand-logo">
    <img
      src={dark ? "/assets/logo-dark.png" : "/assets/logo.png"}
      alt="OtraRoom Trasteros"
      className="h-10 w-auto"
    />
    <div
      className={`font-mono text-[8px] font-bold tracking-[0.34em] mt-1.5 whitespace-nowrap ${
        dark ? "text-white/70" : "text-brand-ink/70"
      }`}
    >
      TRASTEROS
    </div>
  </div>
);
